document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const button = document.querySelector(".join-team-form .btn-submit");
    const colorElement = document.querySelector(".joinTeamBtncolor");

    if (button && colorElement) {
      const joinTeamBgColor = colorElement.getAttribute(
        "joinTeam-btn-bg-color"
      );
      const joinTeamTextColor = colorElement.getAttribute(
        "joinTeam-btn-text-color"
      );
      const joinTeamHoverColor = colorElement.getAttribute("joinTeam-btn-hover-color");
      const joinTeamHoverTextColor = colorElement.getAttribute(
        "joinTeam-btn-hover-text-color"
      );

      button.style.backgroundColor = joinTeamBgColor;
      button.style.color = joinTeamTextColor;

      button.addEventListener("mouseenter", function () {
        button.style.backgroundColor = joinTeamHoverColor;
        button.style.color = joinTeamHoverTextColor;
      });

      button.addEventListener("mouseleave", function () {
        button.style.backgroundColor = joinTeamBgColor;
        button.style.color = joinTeamTextColor;
      });

      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
